import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';

const EstadoCuentaFiltros = ({
    rfcSeleccionado,
    periodoEstadoCuenta,
    setPeriodoEstadoCuenta,
    tipoMovimiento,
    setTipoMovimiento,
    cuentasBancarias = [],
    cuentaSeleccionada,
    setCuentaSeleccionada
}) => {
    return (
        <div className="p-3 bg-light border-bottom">
            <Row className="g-2 align-items-end">
                <Col md={4}>
                    <Form.Group>
                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">
                            <i className="fas fa-building-columns me-1"></i>
                            Cuenta Bancaria
                        </Form.Label>
                        <Form.Select
                            size="sm"
                            value={cuentaSeleccionada}
                            onChange={(e) => setCuentaSeleccionada(e.target.value)}
                            className="form-control"
                            disabled={!rfcSeleccionado}
                        >
                            <option value="">Seleccione una cuenta</option>
                            {cuentasBancarias.map((cuenta) => (
                                <option key={cuenta.idCatCuentaBancaria} value={cuenta.idCatCuentaBancaria}>
                                    {cuenta.vNombreBanco} - {cuenta.vNumCta}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>

                <Col md={4}>
                    <Form.Group>
                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">
                            <i className="far fa-calendar-alt me-1"></i>
                            Período
                        </Form.Label>
                        <DatePicker
                            selected={periodoEstadoCuenta}
                            onChange={(date) => setPeriodoEstadoCuenta(date)}
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            className="form-control form-control-sm"
                            placeholderText="Seleccione mes"
                            disabled={!rfcSeleccionado}
                        />
                    </Form.Group>
                </Col>

                <Col md={4}>
                    <Form.Group>
                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">
                            <i className="fas fa-filter me-1"></i>
                            Tipo de Movimiento
                        </Form.Label>
                        <Form.Select
                            size="sm"
                            value={tipoMovimiento}
                            onChange={(e) => setTipoMovimiento(e.target.value)}
                            className="form-control"
                            disabled={!rfcSeleccionado}
                        >
                            <option value="">Todos</option>
                            <option value="I">● Ingresos</option>
                            <option value="E">● Egresos</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
        </div>
    );
};



EstadoCuentaFiltros.propTypes = {
    rfcSeleccionado: PropTypes.string,
    periodoEstadoCuenta: PropTypes.instanceOf(Date),
    setPeriodoEstadoCuenta: PropTypes.func,
    tipoMovimiento: PropTypes.string,
    setTipoMovimiento: PropTypes.func,
    cuentasBancarias: PropTypes.array,
    cuentaSeleccionada: PropTypes.string,
    setCuentaSeleccionada: PropTypes.func
};

export default EstadoCuentaFiltros;
